import { render, staticRenderFns } from "./PantoneLanding.vue?vue&type=template&id=08d9ce19&scoped=true&"
import script from "./PantoneLanding.vue?vue&type=script&lang=js&"
export * from "./PantoneLanding.vue?vue&type=script&lang=js&"
import style0 from "./PantoneLanding.vue?vue&type=style&index=0&id=08d9ce19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d9ce19",
  null
  
)

export default component.exports